import { ProductDetailThumbnails } from './ProductDetailThumbnails';
import { GalleryItemType } from 'components/Basic/Gallery/Gallery';
import Image from 'components/Basic/Image/Image';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { SimpleFlagType } from 'types/flag';

const Gallery = dynamic(() => import('components/Basic/Gallery/Gallery').then((component) => component.Gallery));

type Props = {
    flags: SimpleFlagType[];
    images: string[];
    productName: string;
    youtubeVideoId: string | null;
};

export const ProductDetailGallery: FC<Props> = ({ images, youtubeVideoId, productName }) => {
    const [activeGalleryIndex, setActiveGalleryIndex] = useState<number | undefined>();
    const { t } = useTranslation();

    if (images.length === 0) {
        return null;
    }

    const mainImage = images[0];

    const galleryImages = (() => {
        const items: GalleryItemType[] = images.map((image) => ({ src: image }));

        if (youtubeVideoId) {
            items.unshift({
                src: `https://www.youtube.com/embed/${youtubeVideoId}`,
                isVideo: true,
            });
        }

        return items;
    })();

    return (
        <div className="w-full lg:flex lg:items-start">
            <button
                onClick={() => setActiveGalleryIndex(youtubeVideoId ? 1 : 0)}
                className="relative my-0 mx-auto block h-[335px] w-full max-w-[600px] lg:order-1 lg:h-[600px] lg:self-stretch"
                tabIndex={0}
            >
                <Image
                    alt={t('Image of ') + productName}
                    src={mainImage}
                    priority
                    fill
                    sizes="(min-width: 768px) 33vw, 100vw"
                />
            </button>
            <ProductDetailThumbnails
                images={images.slice(1, images.length)}
                youtubeVideo={{
                    id: youtubeVideoId,
                    image: mainImage,
                }}
                productName={productName}
                onClick={(index) => setActiveGalleryIndex(index)}
            />
            {activeGalleryIndex !== undefined && (
                <Gallery
                    galleryItems={galleryImages}
                    onCloseCallback={() => setActiveGalleryIndex(undefined)}
                    startIndex={activeGalleryIndex}
                />
            )}
        </div>
    );
};
